import type { Routes } from '@angular/router';

import { HomePage } from './pages/home/home.page';
import { authGuard } from './shared/guards/auth.guard';
import { consentGuard } from './shared/guards/consent.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomePage,
    canMatch: [authGuard],
    canActivate: [consentGuard],
    children: [
      {
        path: '',
        redirectTo: 'gallery',
        pathMatch: 'full',
      },
      {
        path: 'gallery',
        loadChildren: () => import('./pages/gallery/gallery.routes').then(m => m.routes),
      },
      ...(FEATURE_BLE
        ? [{ path: '', loadChildren: () => import('./pages/home-ble-feature.routes').then(m => m.routes) }]
        : [{ path: 'cameras', loadChildren: () => import('./pages/cameras/cameras.routes').then(m => m.routes) }]),
      {
        path: 'contacts',
        loadComponent: () => import('./pages/menu-contacts/contacts.page').then(m => m.ContactsPage),
      },
      {
        path: 'subscriptions',
        loadComponent: () => import('./pages/subscriptions-and-plans/subscriptions-and-plans.page').then(m => m.SubscriptionsAndPlansPage),
      },
      {
        path: 'ballistics',
        loadComponent: () => import('./pages/ballistics/ballistics.page').then(m => m.BallisticsPage),
        data: { showTabBar: true },
      },
      {
        path: 'slot-manager',
        loadChildren: () => import('./pages/slot-manager/slot-manager.routes').then(m => m.slotManagerRoutes),
      },
      {
        path: 'map',
        loadComponent: () => import('./pages/maps/map.page').then(m => m.MapPage),
        data: { showTabBar: true },
      },
      ...(FEATURE_TEST_SECTION
        ? [
            {
              path: 'tests/shot-analysis',
              loadComponent: () => import('./pages/menu/tests/shot-analysis-tests-page/shot-analysis-tests.page').then(m => m.ShotAnalysisTestsPage),
            },
            {
              path: 'tests/videoplayer',
              loadComponent: () => import('./pages/menu/tests/video-player-test/video-player-test').then(m => m.VideoPlayerTest),
            },
            {
              path: 'tests/webrtc',
              loadChildren: () => import('./pages/menu/tests/webrtc-test/webrtc-test.routes').then(m => m.routes),
            },
            ...(FEATURE_BLE
              ? [
                  {
                    path: 'tests/sync-debug',
                    loadComponent: () => import('./pages/menu/tests/sync-debug-view/sync-debug-view.page').then(m => m.SyncDebugViewPage),
                  },
                ]
              : []),
          ]
        : []),
    ],
  },

  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'add-camera-flow',
    loadChildren: () => import('./pages/add-camera-flow/add-camera-flow.routes').then(m => m.routes),
  },
];
